export default __webpack_public_path__ + "static/media/pokemon-logo.0d557d6f.svg";